import { FEATURE_NAME } from './consts';

export const CREATE_QUESTION = `${FEATURE_NAME}/CREATE_QUESTION`;
